import { Messages } from 'lib/intl/messages';
import {
  InvoicePredictionDetailType,
  InvoiceDetailType,
  InvoiceDetailContactType,
  InvoiceDetailContactAddressType,
  InvoiceAdditionalPropertiesType,
  InvoiceDetailSupplierType,
  InvoiceDetailClientType,
} from 'lib/api/invoiceDetails';

export const messages: Messages = {
  INVOICE_DETAILS: {
    en: 'Details',
    de: 'Merkmale',
  },
  INVOICE_DETAIL_DELETE_DIALOG_TITLE: {
    en: 'Are you sure that you want to delete this invoice?',
    de: 'Sind sie sicher, dass sie diese Rechnung(en) löschen wollen?',
  },
  'INVOICE_DETAIL.VALUE.INVOICE': {
    en: 'Invoice',
    de: 'Rechnung',
  },
  'INVOICE_DETAIL.VALUE.CREDIT_MEMO': {
    en: 'Credit memo',
    de: 'Gutschrift',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DeliveryDate}`]: {
    en: 'Delivery date',
    de: 'Lieferdatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.GrandTotalAmount}`]: {
    en: 'Grand total amount',
    de: 'Gesamtsumme',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.NetTotalAmount}`]: {
    en: 'Net total amount',
    de: 'Nettogesamtbetrag',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.VatTotalAmount}`]: {
    en: 'VAT total amount',
    de: 'MWST-Gesamtbetrag',
  },
  // [`INVOICE_DETAIL.${InvoicePredictionDetailType.StrabagRefCode}`]: {
  //   en: 'Strabag ref code',
  //   de: 'Strabag Ref-Code',
  // },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.VatRate}`]: {
    en: 'VAT rate',
    de: 'MWST-Satz',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.InvoiceDate}`]: {
    en: 'Invoice date',
    de: 'Rechnungsdatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.InvoiceId}`]: {
    en: 'Invoice ID',
    de: 'Rechnungs-ID',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DocumentType}`]: {
    en: 'Document type',
    de: 'Dokumenttyp',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.Iban}`]: {
    en: 'IBAN',
    de: 'IBAN',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.VatAmount}`]: {
    en: 'VAT amount',
    de: 'MWST-Betrag',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.InvoiceCurrency}`]: {
    en: 'Invoice currency',
    de: 'Rechnungswährung',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DeliveryNoteId}`]: {
    en: 'Delivery note ID',
    de: 'Lieferschein-ID',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.CustomerId}`]: {
    en: 'Customer ID',
    de: 'Kundennummer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.VatId}`]: {
    en: 'VATID',
    de: 'UId',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.SenderVatId}`]: {
    en: 'Sender VATID',
    de: 'Absender UId',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.ReceiverVatId}`]: {
    en: 'Receiver VATID',
    de: 'Empfänger UId',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.SenderOrderId}`]: {
    en: 'Sender order ID',
    de: 'Absender Bestellnummer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.ReceiverOrderId}`]: {
    en: 'Receiver order ID',
    de: 'Empfänger Bestellnummer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.SenderOrderDate}`]: {
    en: 'Sender order date',
    de: 'Absender Bestelldatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.ReceiverOrderDate}`]: {
    en: 'Receiver order date',
    de: 'Empfänger Bestelldatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.NetAmount}`]: {
    en: 'Net amount',
    de: 'Netto-Betrag',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.VatGroup}`]: {
    en: 'VAT group',
    de: 'MWST-Gruppe',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.KId}`]: {
    en: 'KId',
    de: 'KId',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.IsrReference}`]: {
    en: 'Isr Reference',
    de: 'Isr Referenz',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.IsrSubscriber}`]: {
    en: 'Isr Subscriber',
    de: 'Isr Teilnehmer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DiscountGroup}`]: {
    en: 'Discount Group',
    de: 'Rabattgruppe',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DiscountDate}`]: {
    en: 'Discount Date',
    de: 'Rabattdatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DiscountDuration}`]: {
    en: 'Discount Duration',
    de: 'Rabattdauer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DiscountPercent}`]: {
    en: 'Discount Percent',
    de: 'Rabatthöhe (Prozent)',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DueDateGroup}`]: {
    en: 'Due Date Group',
    de: 'Fälligkeitsgruppe',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DueDateDate}`]: {
    en: 'Due Date Date',
    de: 'Fälligkeitsdatum',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.DueDateDuration}`]: {
    en: 'Due Date Duration',
    de: 'Fälligkeitsdauer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.BankGroup}`]: {
    en: 'Bank Group',
    de: 'Bankgruppe',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.BankAccount}`]: {
    en: 'Bank Account',
    de: 'Kontonummer',
  },
  [`INVOICE_DETAIL.${InvoicePredictionDetailType.BankCode}`]: {
    en: 'Bank Code',
    de: 'Bankleitzahl',
  },
  // [`INVOICE_DETAIL.${InvoicePredictionDetailType.OerkBezirksstelle}`]: {
  //   en: 'OeRK district office',
  //   de: 'OeRK Bezirksstellen',
  // },
  [`INVOICE_DETAIL.${InvoiceDetailType.Sender}`]: {
    en: 'Sender',
    de: 'Absender',
  },
  [`INVOICE_DETAIL.${InvoiceDetailType.Receiver}`]: {
    en: 'Receiver',
    de: 'Empfänger',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.Name}`]: {
    en: 'Name',
    de: 'Name',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.Address}`]: {
    en: 'Address',
    de: 'Adresse',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactAddressType.Country}`]: {
    en: 'Country',
    de: 'Land',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactAddressType.City}`]: {
    en: 'City',
    de: 'Stadt',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactAddressType.ZipCode}`]: {
    en: 'ZIP code',
    de: 'PLZ',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactAddressType.Street}`]: {
    en: 'Street',
    de: 'Straße',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.WebsiteUrl}`]: {
    en: 'Website URL',
    de: 'Webseite',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.Email}`]: {
    en: 'Email',
    de: 'E-Mail',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.Phone}`]: {
    en: 'Phone',
    de: 'Telefon',
  },
  [`INVOICE_DETAIL.${InvoiceDetailContactType.Fax}`]: {
    en: 'Fax',
    de: 'Fax',
  },
  [`INVOICE_DETAIL.${InvoiceDetailType.AdditionalProperties}`]: {
    en: 'Additional Properties',
    de: 'Meta Daten',
  },
  [`INVOICE_DETAIL.${InvoiceAdditionalPropertiesType.ClientId}`]: {
    en: 'Client ID',
    de: 'Mandanten ID',
  },
  [`INVOICE_DETAIL.${InvoiceAdditionalPropertiesType.ReceiverEmail}`]: {
    en: 'Receiver Email',
    de: 'Empfänger E-Mail',
  },
  [`INVOICE_DETAIL.${InvoiceAdditionalPropertiesType.SenderEmail}`]: {
    en: 'Sender Email',
    de: 'Sender E-Mail',
  },
  [`INVOICE_DETAIL.${InvoiceDetailType.Supplier}`]: {
    en: 'Supplier',
    de: 'Lieferanten',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.SupplierId}`]: {
    en: 'Supplier ID',
    de: 'Lieferanten ID',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.Name}`]: {
    en: 'Name',
    de: 'Name (Lieferant)',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.Uids}`]: {
    en: 'UID',
    de: 'UstID',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.Ibans}`]: {
    en: 'IBAN',
    de: 'IBAN',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.City}`]: {
    en: 'City',
    de: 'Stadt',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.Country}`]: {
    en: 'Country',
    de: 'Land (Lieferant)',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.Street}`]: {
    en: 'Street',
    de: 'Straße',
  },
  [`INVOICE_DETAIL.${InvoiceDetailSupplierType.ZipCode}`]: {
    en: 'Zip Code',
    de: 'PLZ',
  },
  [`INVOICE_DETAIL.${InvoiceDetailType.Client}`]: {
    en: 'Client',
    de: 'Mandant',
  },
  [`INVOICE_DETAIL.${InvoiceDetailClientType.Name}`]: {
    en: 'Name',
    de: 'Name',
  },
  [`INVOICE_DETAIL.${InvoiceDetailClientType.Id}`]: {
    en: 'Client ID',
    de: 'Mandanten ID',
  },
  [`INVOICE_DETAIL.Bic`]: {
    en: 'Bic',
    de: 'Bic',
  },
  [`INVOICE_DETAIL.NO_RESULTS`]: {
    en: 'No Results',
    de: 'Keine Ergebnisse',
  },
  [`LINE_ITEMS`]: {
    en: 'Line items',
    de: 'Artikelpositionen',
  },
  [`LINE_ITEM_FIELD.PositionNumber`]: {
    en: 'Position Number',
    de: 'Positionsnummer',
  },
  [`LINE_ITEM_FIELD.PositionId`]: {
    en: 'Position ID',
    de: 'Positions ID',
  },
  [`LINE_ITEM_FIELD.DeliveryId`]: {
    en: 'Delivery ID',
    de: 'Lieferungs ID',
  },
  [`LINE_ITEM_FIELD.OrderId`]: {
    en: 'Order ID',
    de: 'Auftragsnummer',
  },
  [`LINE_ITEM_FIELD.ItemId`]: {
    en: 'Item ID',
    de: 'Artikel ID',
  },
  [`LINE_ITEM_FIELD.Description`]: {
    en: 'Description',
    de: 'Beschreibung',
  },
  [`LINE_ITEM_FIELD.Unit`]: {
    en: 'Unit',
    de: 'Einheit',
  },
  [`LINE_ITEM_FIELD.DeliveryDate`]: {
    en: 'Delivery Date',
    de: 'Lieferdatum',
  },
  [`LINE_ITEM_FIELD.Quantity`]: {
    en: 'Quantity',
    de: 'Menge',
  },
  [`LINE_ITEM_FIELD.UnitPrice`]: {
    en: 'Unit Price',
    de: 'Stückpreis',
  },
  [`LINE_ITEM_FIELD.Discount`]: {
    en: 'Discount',
    de: 'Rabatt',
  },
  [`LINE_ITEM_FIELD.VatRate`]: {
    en: 'VAT Rate',
    de: 'MwSt.-Satz',
  },
  [`LINE_ITEM_FIELD.TotalAmount`]: {
    en: 'Total Amount',
    de: 'Gesamtsumme',
  },
};
